import { mobileRouter } from './mobile'
import { pcRouter } from './pc'

const isMobileBuild = import.meta.env.VITE_PLATFORM === 'MOBILE'

export const router = isMobileBuild ? mobileRouter : pcRouter
